var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"pages":[{ title: 'Home' }, { title: 'Withdraw', isActive: true  }]}}),_c('b-row',{staticClass:"liquidity justify-content-md-center mb-5"},[_c('b-col',{attrs:{"md":"5"}},[_c('Withdraw')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }